document.addEventListener('DOMContentLoaded', function() {
  var colorSelect = document.querySelector('select[name="味"]');
  var sizeSelect = document.querySelector('select[name="オプション"]');

  if (colorSelect && sizeSelect) {
    colorSelect.addEventListener('change', function() {
      var selectedColor = colorSelect.value;
      var specificColor = 'マスカット(アルコール度数6.5%)'; // ここに特定の色を入力してください

      Array.from(sizeSelect.options).forEach(function(option) {
        var specificSize = '特定のサイズ'; // ここに特定のサイズを入力してください
        if (selectedColor === specificColor && option.value === specificSize) {
          option.style.display = 'block';
        } else if (option.value === specificSize) {
          option.style.display = 'none';
        }
      });
    });

    // 初期状態で特定のサイズを非表示にする
    colorSelect.dispatchEvent(new Event('change'));
  }
});
console.log("helloworld");